import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { getUserProfile } from "../../../services/api/user/getUserProfile";

export const QUERY_USERS_USER_PROFILE_V2 = "QUERY_USERS_USER_PROFILE_V2";

export const useQueryUserProfileV2 = (
  queryConfig?: WSQueryConfig<
    Awaited<ReturnType<typeof getUserProfile>>,
    WSServiceError
  >
) => {
  return useWSQuery(QUERY_USERS_USER_PROFILE_V2, getUserProfile, {
    refetchOnMount: false,
    ...queryConfig
  });
};
